import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  inputContainer: {
    position: 'absolute',
    bottom: 0,
    padding: theme.spacing(2),
    width: '100%',
  },
  inputPaper: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    borderRadius: '24px',
    border: `1px solid ${theme.palette.divider}`,
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
    '&:focus-within': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
    },
    transition: 'all 0.3s ease',
  },
  textField: {
    flex: 1,
    margin: theme.spacing(1, 0),
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
  },
  sendButton: {
    color: theme.palette.primary.main,
    padding: '5px',
  },
  fileButton: {
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.main,
    padding: '5px',
  },

  messageBubble: {
    backgroundColor: '#f5f5f5',
    wordBreak: 'break-word',
  },
  editActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(-1),
    marginRight: theme.spacing(-0.5),
  },
  editField: {
    '& .MuiInputBase-root': {
      padding: 0,
    },
  },
  editInput: {
    padding: 0,
    margin: 0,
  },

  filesPreviewContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  fileThumbnail: {
    width: 80,
    height: 80,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: theme.palette.grey[100],
    '&:hover $fileRemoveButton': {
      opacity: 1,
    },
  },
  fileDocument: {
    width: 80,
    height: 80,
    backgroundColor: theme.palette.grey[400],
    borderRadius: theme.shape.borderRadius,
    '& .MuiSvgIcon-root': {
      fontSize: '2.5rem',
    },
  },
  fileImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  fileInfo: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: 'white',
    paddingInline: theme.spacing(0.5),
  },
  fileRemoveButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: theme.palette.error.main,
    opacity: 0,
    transition: 'opacity 0.2s',
  },
}));

export default useStyles;
